<template>
  <div v-if="document_person_data.person!=null">
    <CRow>
      <CCol md="12">
        <CCardHeader class="p-1">
          <CRow>
            <CCol col="4" style="text-align: center ;padding:10px 20px 0 20px ">

            </CCol>

            <CCol col="8" style="text-align: end">
              <CRow style="justify-content: end;margin:0px">
                <CButton v-if="!get_access('hyper_sale') && doc_status==0 && get_access('document_save_print')"
                         @click="finalize(true)" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{ $t('savePrint') }}
                </CButton>
                <CButton v-if="doc_status==0" @click="finalize(false)" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{ $t('save') }}
                </CButton>


                <CButton
                    @click="print_element('printCustomer',doc_id_no)"
                    size="sm"
                    color="secondary"
                    class="mr-1">
                  پرینت رسید مشتری
                </CButton>
                <CButton
                    @click="print_element('printTech',doc_id_no)"
                    size="sm"
                    color="secondary"
                    class="mr-1">
                  پرینت رسید تکنسین
                </CButton>
                <CButton  @click="open_document(1)" size="sm"
                         color="secondary"
                         class="mr-1">

                  سند خرید
                </CButton>
                <CButton  @click="open_document(3)" size="sm"
                         color="secondary"
                         class="mr-1">

                سند فروش
                </CButton>
                <CButton  @click="pre_finalize=true" size="sm"
                         color="secondary"
                         class="mr-1">

                  تغییر وضعیت
                </CButton>
                <CButton v-if="doc_status==0" @click="delete_item_dialog()" size="sm"
                         color="secondary"
                         class="mr-1">

                  {{ $t('buttons.delete') }}
                </CButton>

              </CRow>

            </CCol>
          </CRow>
        </CCardHeader>
        <div v-show="false">

          <div id="print_report_footer">

            <div style="width: 100%;">
              <CCardHeader>

                <CRow>
                  <CCol sm="4" md="4" style="text-align: start">
                    <!--                  <h6>{{ $t('docCreator') }} : {{ my_branch_code() }}/{{ get_user_name() }}</h6>-->
                    <h6>{{ $t('docCreator') }} : {{ document_visitor }} </h6>
                    <h6> {{ get_time(createdAt) }}</h6>
                    <h6>Sign</h6>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: center">
                    <h6 class="pageFooter_no1"></h6>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: end">
                    <h6>{{ $t('components.customer') }}</h6>
                    <h6>Sign</h6>

                  </CCol>
                </CRow>

              </CCardHeader>

            </div>
          </div>
        </div>
        <div id="print_report_header">
          <CCardHeader>
            <CRow>

              <CCol sm="4" md="4" style="text-align: right">
                <!--                  <h2 >{{ get_date(new Date()) }}</h2>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: center">
                <!--                                    <h2>{{types_parent.filter(x=>x.value ==selected_type_parent)[0].label}}</h2>-->

                <!--                <p style="font-weight: bold;" v-if="doc_status!=0">{{ $t('factor') }}</p>-->
                <!--                <p style="font-weight: bold;" v-else>{{ $t('request_order') }}</p>-->

                <h6 style="font-weight: bold;" v-if="doc_status==0">{{
                    $t('SaleOrder')
                  }}</h6>
                <h6 style="font-weight: bold;" v-if=" doc_status==1">{{
                    $t('factor')
                  }}</h6>
                <!--                <h6 style="font-weight: bold;" v-else>{{ $t('request_order') }}</h6>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: left">
                <!--                  <CImg :src="get_logo()" width="100px" height="50px"/>-->

              </CCol>
            </CRow>
            <CRow style="background-color: rgba(249,246,217,0.28);direction: rtl">
              <CCol style="direction: initial" col="4">
                <table style="float:right">
                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}
                      <a v-if="baseMasterId!=null" target="_blank"
                         :href="'/dashboard/documents/show/'+baseMasterId">({{ baseMasterCode }})</a>

                    </td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}
                      <a v-if="baseMasterId!=null" target="_blank"
                         :href="'/dashboard/documents/show/'+baseMasterId">{{ baseMasterCode }}</a>
                    </td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('request_order_no') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('payDueDate') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ document_visitor }}</td>

                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: left">{{ $t('docCreator') }}</td>

                  </tr>

                </table>
              </CCol>

              <CCol col="8" class="text-left">

                <div>
                  <table style="float: left">
                    <tr>
                      <th style=";padding-top: 0;text-align: end" class="pr-2 pl-2">
                        <h6 class="m-0" style="font-weight: bold;font-size: 20px">{{
                            bissiness_profile.businessName
                          }}</h6>
                        <p class="m-0"
                           v-if="bissiness_profile.vatNumber!=null && bissiness_profile.vatNumber!=''">
                          {{ $t('economicalCode') }} {{ bissiness_profile.vatNumber }}</p>
                        <p class="m-0" style="direction: ltr;text-align: left;">{{
                            company_address
                          }}</p>
                        <!--                                                <p class="m-0">{{ bissiness_profile.vatNumber }}</p>-->
                        <p class="m-0" style="direction: ltr;text-align: left;"><span
                            v-for="(phone_obj,index) in phone_objects" :key="'i'+index">{{ phone_obj.phone }} <span
                            v-if="index != phone_objects.length-1"> - </span></span></p>
                        <p class="m-0">{{ email_objects[0].phone }}</p>
                      </th>
                      <th width="100px">
                        <CImg :src="get_logo()" width="100px" height="50px"/>
                      </th>
                    </tr>
                  </table>
                </div>

              </CCol>
            </CRow>
            <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">

            <CRow>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('billTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0"> {{ document_person }} </p>
                <!--                                <p>{{partyMobile}} </p>-->
                <p class="m-0" v-if="document_person_data.personAddress[0] !=null">
                  {{ document_person_data.personAddress[0].addressText }}
                  {{ document_person_data.personAddress[0].cityName }}
                  {{ document_person_data.personAddress[0].regionName }}
                  {{ document_person_data.personAddress[0].areaRelName }}

                </p>

                <p class="m-0" v-if="document_person_data.personAddress.length>0">
                  {{ document_person_data.personAddress[0].postCode }}</p>
                <p class="m-0">{{ partyMobile }} </p>

              </CCol>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('shipTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0" v-if="document_person_data.personAddress[1] !=null"> {{
                    document_person
                  }} </p>

                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].addressText }}
                  {{ document_person_data.personAddress[1].cityName }}
                  {{ document_person_data.personAddress[1].regionName }}
                  {{ document_person_data.personAddress[1].areaRelName }}
                </p>
                <!--                <p class="m-0" v-else>-->
                <!--                  {{ document_person_data.personAddress[0].addressText }}-->
                <!--                  {{ document_person_data.personAddress[0].cityName }}-->
                <!--                  {{ document_person_data.personAddress[0].regionName }}-->
                <!--                  {{ document_person_data.personAddress[0].areaRelName }}-->
                <!--                </p>-->

                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].postCode }}</p>
                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].phoneNo }}</p>

              </CCol>
            </CRow>
          </CCardHeader>

        </div>
        <div id="print_report_header_low" style="display: none">
          <CCardHeader>
            <CRow>

              <CCol sm="4" md="4" style="text-align: right">
                <!--                  <h2 >{{ get_date(new Date()) }}</h2>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: center">
                <!--                                    <h2>{{types_parent.filter(x=>x.value ==selected_type_parent)[0].label}}</h2>-->

                <!--                <p style="font-weight: bold;" v-if="doc_status!=0">{{ $t('factor') }}</p>-->
                <!--                <p style="font-weight: bold;" v-else>{{ $t('request_order') }}</p>-->

                <h6 style="font-weight: bold;" v-if=" doc_status==0">{{
                    $t('PurchaseOrder')
                  }}</h6>

                <h6 style="font-weight: bold;" v-if=" doc_status==1">{{
                    $t('factor')
                  }}</h6>
                <!--                <h6 style="font-weight: bold;" v-else>{{ $t('request_order') }}</h6>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: left">
                <!--                  <CImg :src="get_logo()" width="100px" height="50px"/>-->

              </CCol>
            </CRow>
            <CRow style="background-color: rgba(249,246,217,0.28);direction: rtl">
              <CCol style="direction: initial" col="4">
                <table style="float:right">
                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('request_order_no') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('payDueDate') }}</td>
                  </tr>
                </table>
              </CCol>

              <CCol col="8" class="text-left">

                <div>
                  <table style="float: left">
                    <tr>
                      <th style=";padding-top: 0;text-align: end" class="pr-2 pl-2">
                        <h6 class="m-0" style="font-weight: bold;font-size: 20px">{{
                            bissiness_profile.businessName
                          }}</h6>
                        <p class="m-0"
                           v-if="bissiness_profile.vatNumber!=null && bissiness_profile.vatNumber!=''">
                          {{ $t('economicalCode') }} {{ bissiness_profile.vatNumber }}</p>
                        <p class="m-0" style="direction: ltr;text-align: left;">{{
                            company_address
                          }}</p>
                        <!--                                                <p class="m-0">{{ bissiness_profile.vatNumber }}</p>-->
                        <p class="m-0" style="direction: ltr;text-align: left;"><span
                            v-for="(phone_obj,index) in phone_objects" :key="'i'+index">{{ phone_obj.phone }} <span
                            v-if="index != phone_objects.length-1"> - </span></span></p>
                        <p class="m-0">{{ email_objects[0].phone }}</p>
                      </th>
                      <th width="100px">
                        <CImg :src="get_logo()" width="100px" height="50px"/>
                      </th>
                    </tr>
                  </table>
                </div>

              </CCol>
            </CRow>
            <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">

            <CRow>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">اطلاعات مشتری</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0"> {{ document_person }} </p>
                <!--                                <p>{{partyMobile}} </p>-->
                <p class="m-0" v-if="document_person_data.personAddress[0] !=null">
                  {{ document_person_data.personAddress[0].addressText }}
                  {{ document_person_data.personAddress[0].cityName }}
                  {{ document_person_data.personAddress[0].regionName }}
                  {{ document_person_data.personAddress[0].areaRelName }}

                </p>

                <p class="m-0" v-if="document_person_data.personAddress.length>0">
                  {{ document_person_data.personAddress[0].postCode }}</p>
                <p class="m-0">{{ partyMobile }} </p>

              </CCol>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('shipTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0" v-if="document_person_data.personAddress[1] !=null"> {{
                    document_person
                  }} </p>

                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].addressText }}
                  {{ document_person_data.personAddress[1].cityName }}
                  {{ document_person_data.personAddress[1].regionName }}
                  {{ document_person_data.personAddress[1].areaRelName }}
                </p>
                <!--                <p class="m-0" v-else>-->
                <!--                  {{ document_person_data.personAddress[0].addressText }}-->
                <!--                  {{ document_person_data.personAddress[0].cityName }}-->
                <!--                  {{ document_person_data.personAddress[0].regionName }}-->
                <!--                  {{ document_person_data.personAddress[0].areaRelName }}-->
                <!--                </p>-->

                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].postCode }}</p>
                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].phoneNo }}</p>

              </CCol>
            </CRow>

          </CCardHeader>

        </div>


        <CCard>
          اطلاعات کارتابل
          <CRow>
            <CCol col="3">
              نام کارتابل:
              {{ cartable_data.requestName }}
            </CCol>
            <CCol col="3">
              دسته:
              {{ cartable_data.catName }}
            </CCol>
            <CCol col="3">
              برند:
              {{ cartable_data.brandName }}
            </CCol>
            <CCol col="3">
              مدل:
              {{ cartable_data.modelNo }}
            </CCol>
            <CCol col="3">
              سریال:
              {{ cartable_data.serialNo }}
            </CCol>
            <CCol col="4">
              توضیحات مشتری:
              {{ cartable_data.reqDesc }}
            </CCol>
            <CCol col="4">
              توضیحات تکنسین:
              {{ cartable_data.techDesc }}
            </CCol>
            <CCol col="4">
              لوازم همراه:
              {{ cartable_data.extraInfo }}
            </CCol>
            <CCol col="3">
              قفسه:
              {{ cartable_data.device_wharehouse_location }}
            </CCol>
            <CCol col="4">
              توضیحات مخفی:
              {{ cartable_data.device_tech_hidden_description }}
            </CCol>
            <CCol col="3">
              آخرین وضعیت:
              {{ cartable_data.lastStatus }}
            </CCol>
          </CRow>

          <CCardBody id="printTech">
            <!--                        <p v-if="document_summary!=null">{{ $t('components.factorSummary') }}: {{ document_summary-->
            <!--                            }} </p>-->
            <!--                        <hr v-if="document_summary!=null" class="mt-0">-->
            <div style="padding:3px;">
              <CDataTable
                  :items="product_items"
                  :fields="fields"
                  striped
                  border

                  :items-per-page="200"
                  hover
                  pagination
              >
                <template #row="{item}">

                  <td style="text-align: center">
                    <strong>{{ item.row_id + 1 }}</strong>

                  </td>

                </template>
                <template #name="{item}">
                  <td>
                    <strong>{{ item.productCode }} {{ item.productName }}</strong>
                  </td>
                </template>

                <template #unit="{item}">
                  <td>
                    <strong>{{ item.value }}</strong>
                  </td>
                </template>

                <template #qty="{item}">
                  <td style="text-align: right">
                    <strong style="text-align: right">{{
                        Math.abs(item.qty)
                      }}</strong>

                  </td>
                </template>
                <template #productUnitName="{item}">
                  <td>
                    <strong>{{ item.productUnitName }}</strong>
                  </td>
                </template>
                <template #price="{item}">
                  <td>
                    <strong style="float: right">{{ get_currency(item.price) }} </strong>
                  </td>
                </template>
                <template #totalPrice="{item}">

                  <td>
                    <strong style="float: right">{{ get_currency(item.totalPrice) }} </strong>

                  </td>

                </template>
                <template #takhfif="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.takhfif)
                      }} </strong>

                  </td>

                </template>
                <template #tax="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.tax)
                      }} </strong>

                  </td>

                </template>
                <template #summary="{item}">

                  <td>
                    <strong>{{ item.docDesc }}</strong>

                  </td>

                </template>


              </CDataTable>


            </div>
            <CCardBody class="mb-5">
              <CRow>
                <CCol col="7">
                  <p style="font-width: bold;" v-if="document_summary!=null">
                    {{ document_summary }}</p>
                  <p class="mb-1" v-for="(message,index) in messages_items" :key="'m'+index">{{
                      message.message
                    }}</p>
                  <br>

                  <div style="bottom: 0;position: absolute;width: 100%;">
                    <hr class="m-0">

                    <p class="mb-1">{{ selected_place }} | {{ $t('weightOfInvoice') }} {{
                        get_weight(total_weight)
                      }} {{ $t('kg') }}</p>
                  </div>
                </CCol>
                <CCol col="5">

                  <CDataTable
                      :items="document_result_price"
                      :fields="fields_total_price"
                      striped
                      border
                      :responsive="false"
                      :items-per-page="200"
                      hover
                      pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{
                            get_currency(item.resultPrice)
                          }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{
                            get_currency(item.resultPrice)
                          }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                </CCol>
              </CRow>

            </CCardBody>

          </CCardBody>
        </CCard>

        <CCard style="display: block">
          رسید مشتری

          <CCardBody id="printCustomer">
            <div style="padding:15px;">
              <CRow style=";margin:2px 0">
                <CCol col="2">
                  <CImg :src="get_logo()" width="100px" height="50px"/>

                </CCol>
                <CCol style="border: 2px solid black;border-radius: 10px">
                  <div class="d-flex justify-content-between">
                    <label>
                      {{
                        bissiness_profile.businessName
                      }}
                    </label>
                    <label>
                      آدرس:
                      {{
                        company_address
                      }}
                    </label>
                  </div>
                  <div class="d-flex justify-content-between">
                    <label>تعهد تخصص تجربه</label>
                    <label>
                      <p class="m-0" style="direction: ltr;">
                        شماره های تماس:
                        <span
                            v-for="(phone_obj,index) in phone_objects" :key="'i'+index">{{ phone_obj.phone }} <span
                            v-if="index != phone_objects.length-1"> - </span></span></p>
                      <p class="m-0">{{ email_objects[0].phone }}</p>

                    </label>
                  </div>

                </CCol>
              </CRow>
              <CRow style="border: 2px solid black;border-radius: 10px;margin:2px 0">
                <CCol style="border-left: 2px solid black">
                  <div class="d-flex justify-content-between">
                    <label>شماره کارتابل:</label>
                    <label>{{ cartable_data.requestCode }}</label>
                  </div>
                  <div class="d-flex justify-content-between">
                    <label>تاریخ پذیرش:</label>
                    <label>{{ get_date(cartable_data.createdAt) }}</label>
                  </div>
                  <div class="d-flex justify-content-between">
                    <label>شماره سریال:</label>
                    <label>{{ (cartable_data.serialNo) }}</label>
                  </div>
                </CCol>
                <CCol >
                  <div class="d-flex justify-content-between">
                    <label>نوع:</label>
                    <label>{{ cartable_data.catName }}</label>
                  </div>
                  <div class="d-flex justify-content-between">
                    <label>برند:</label>
                    <label>{{ cartable_data.brandName }}</label>
                  </div>
                  <div class="d-flex justify-content-between">
                    <label>مدل:</label>
                    <label>{{ cartable_data.modelNo }}</label>
                  </div>

                </CCol>

              </CRow>
              <CRow style="border: 2px solid black;border-radius: 10px;margin:2px 0">
                <CCol col="6">
                  <label>نام مشتری:</label>
                  <label>{{ document_person }} </label>
                </CCol>
                <CCol col="6">
                  <label>شماره تماس:</label>
                  <label>{{ partyMobile }} </label>
                </CCol>
                <CCol col="12">
                  <label>آدرس:</label>
                  <label class="m-0" v-if="document_person_data.personAddress[0] !=null">
                    {{ document_person_data.personAddress[0].addressText }}
                    {{ document_person_data.personAddress[0].cityName }}
                    {{ document_person_data.personAddress[0].regionName }}
                    {{ document_person_data.personAddress[0].areaRelName }}

                  </label>
                </CCol>

              </CRow>
              <CRow style="border: 2px solid black;border-radius: 10px;margin:2px 0">
                <CCol  style="border-left: 2px solid black">
                  <div class="">
                    <label>متعلقات:</label>
                    <label>{{ cartable_data.extraInfo }}</label>
                  </div>
                </CCol>
                <CCol>
                  <div class="">
                    <label>توضیحات تکنسین:</label>
                    <label>{{ cartable_data.techDesc }}</label>
                  </div>
                </CCol>
              </CRow>
              <CRow style="border: 2px solid black;border-radius: 10px;margin:2px 0">
                <CCol>
                  <div class="">
                    <label>توضیحات مشتری:</label>
                    <label>{{ cartable_data.reqDesc }}</label>
                  </div>
                </CCol>
              </CRow>
              <CRow style="border: 2px solid black;border-radius: 10px;margin:2px 0">
                <CCol>
                  <div class="">
                    باعث افتخار ماست که مجموعه مگابایت سیستم را انتخاب کردید.
                    <ul>
                      <li>
                        نصب ویندوز و خدمات نرم افزاری شامل گارانتی نمی شود؛
                      </li>
                      <li>
                        . دستگاه پس از تعمیر به مدت یک ماه نزد مگابایت سیستم به امانت می ماند بعد از مدت مقرر هیچگونه
                        مسئولیتی در قبال دستگاه پذیرا نیست؛

                      </li>
                      <li>
                        تمام دستگاه های خارج شده از این مرکز دارای پلمپ می باشند و در صورت مخدوش شدن پلمپ مجموعه مگابایت
                        هیچ ادعایی را نمی پذیرد؛

                      </li>
                      <li>
                        حداقل زمان برای عیب یابی کامل دستگاه و برآورد هزینه 24 ساعت کاری می باشد در صورت نیاز به زمان
                        بیشتر تکنسین طی تماس با شما هماهنگ خواهد کرد؛

                      </li>
                      <li>
                        پس از عیب یایی کامل دستگاه در صورتیکه مشتری از تعمیر منصرف شود مبلغ 1.100.000 تومان جهت باز و
                        بست و عیب یابی دریافت میگردد؛

                      </li>
                      <li>
                        به دلیل عدم امکان تست دستگاه در هنگام پذیرش عیوب غیر قابل مشاهده و یا عنوان نشده دستگاه تعهدی
                        برای شرکت ایجاد نمیکند و پس از تست و بررسی کامل متعاقبا اعلام خواهد شد.
                      </li>
                    </ul>
                  </div>
                </CCol>
              </CRow>
              <CRow style=";margin:2px 0">
                <CCol style="border: 2px solid black;border-radius: 10px;height: 100px">
                  مهر و امضا شرکت
                </CCol>
                <CCol style="border: 2px solid black;border-radius: 10px;height: 100px">
                  امضا مشتری
                </CCol>
              </CRow>
            </div>
            <CCardBody class="mb-5">
              <CRow>
                <CCol col="12">
                  <p style="font-width: bold;" v-if="document_summary!=null">
                    {{ document_summary }}</p>
                  <p class="mb-1" v-for="(message,index) in messages_items" :key="'j'+index">{{
                      message.message
                    }}</p>
                  <br>


                </CCol>
              </CRow>

            </CCardBody>

          </CCardBody>
          <CCardBody class="mb-5">
            <CRow>
              <CCol col="7">

                <p class="mb-1" v-for="(message,index) in messages_items" :key="'c'+index">{{
                    message.message
                  }}</p>
                <br>

                <div style="bottom: 0;position: absolute;width: 100%;">
                  <hr class="m-0">
                  <p class="mb-1">{{ selected_place }} | {{ get_weight(total_weight) }} {{
                      $t('kg')
                    }}</p>
                </div>
              </CCol>
              <CCol col="5">

                <CDataTable
                    :items="document_result_price"
                    :fields="fields_total_price"
                    striped
                    border
                    :responsive="false"
                    :items-per-page="200"
                    hover
                    pagination
                >
                  <template #resultTitle="{item}">

                    <td v-if="item.final_price" class="text-danger">
                      <strong>{{ item.resultTitle }}</strong>
                    </td>
                    <td v-else>
                      <strong>{{ item.resultTitle }}</strong>
                    </td>


                  </template>
                  <template #resultPrice="{item}">

                    <td style="text-align: right" v-if="item.final_price" class="text-danger">
                      <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                      <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                    </td>
                    <td style="text-align: right" v-else>
                      <!--                                          <strong > {{currency_symbol()}}</strong>-->
                      <strong v-if="item.currencyTitle=='Base'">{{
                          get_currency(item.resultPrice)
                        }}</strong>
                      <strong v-if="item.currencyTitle!='Base'">{{
                          get_currency(item.resultPrice)
                        }}</strong>
                    </td>

                  </template>

                </CDataTable>
              </CCol>
            </CRow>

          </CCardBody>

        </CCard>

        <CCard v-if="get_access('document_payment_info') && factor_received_amounts.payInfo!=null">
          <CCardHeader>
            اطلاعات فاکتور
          </CCardHeader>
          <CCardBody>

            <CRow>
              <CCol col="4">
                <CCol>دریافتی های توزیع کننده : {{ factor_received_amounts.toziKonande }}</CCol>
                <div v-if="factor_received_amounts.cashId==0" class="bold text-danger text-center">تسویه نشده</div>
                <CDataTable
                    :items="JSON.parse(factor_received_amounts.payInfo)"
                    :fields="factor_received_amounts_fields"
                    :responsive="false"

                >

                  <template #PaymentType="{item}">
                    <td>
                      <p class="m-0" v-if="item.PaymentType==1">کارتخوان</p>
                      <p class="m-0" v-if="item.PaymentType==2">نقد</p>
                      <p class="m-0" v-if="item.PaymentType==3">چک</p>
                      <p class="m-0" v-if="item.PaymentType==4">رسید</p>
                      <p class="m-0" v-if="item.PaymentType==5">مرجوعی</p>
                    </td>
                  </template>
                  <template #Price="{item}">
                    <td>
                      <p class="m-0">{{ get_currency(item.Price) }}</p>
                    </td>
                  </template>
                </CDataTable>
                <CImg :src="factor_received_amounts.signtrue" width="200px" height="200px"/>

              </CCol>
              <CCol col="8">
                <CCol>تراکنش های فاکتور</CCol>

                <CDataTableFixed
                    :items="payments_invoice"
                    :fields="fields_payments_invoice"
                    :items-per-page="200"
                    hover

                    border
                    striped

                >
                  <template #row="{item,index}">

                    <td>
                      <p class="text-center">{{ index + 1 }}</p>

                    </td>

                  </template>
                  <template #docDate="{item}">

                    <td>
                      <p class="text-center">{{ get_date(item.docDate) }}</p>

                    </td>

                  </template>

                  <template #balance="{item}">
                    <td>
                      <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
                      <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
                      <p class="text-right text-danger" v-if="item.balance<0">{{
                          get_currency(Math.abs(item.balance))
                        }}</p>
                      <p class="text-right" v-else>{{ get_currency(item.balance) }}</p>

                    </td>
                  </template>

                  <template #amount="{item}">
                    <td>
                      <p class="text-right">{{ get_currency(item.amount) }}</p>
                    </td>
                  </template>
                  <template #amountNegetive="{item}">
                    <td>
                      <p class="text-right">{{ get_currency(item.amountNegetive) }}</p>
                    </td>
                  </template>
                  <template #partyName="{item}">

                    <td>
                      <p>{{ item.partyName }}</p>

                    </td>

                  </template>
                  <template #toziKonande="{item}">

                    <td>
                      <p v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>

                    </td>

                  </template>
                  <template #user="{item}">
                    <td>
                      <p>{{ item.createdBy }}</p>
                    </td>
                  </template>
                  <template #masterCode="{item}">
                    <td>
                      <p class="text-center">{{ item.masterCode }}</p>
                    </td>
                  </template>


                  <template #under-table>
                    <CRow>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol>{{ $t('totalCirculation') }}</CCol>
                      <CCol>{{ get_currency(calculate_items(payments_invoice, 'amountNegetive')) }}</CCol>
                      <CCol>{{ get_currency(calculate_items(payments_invoice, 'amount')) }}</CCol>

                    </CRow>
                    <CRow>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>
                      <CCol class="bg-dark text-danger" v-if="calculate_items(payments_invoice,'amountNegetive')
                - calculate_items(payments_invoice,'amount')<0">{{
                          get_currency(Math.abs(calculate_items(payments_invoice, 'amountNegetive')
                              - calculate_items(payments_invoice, 'amount')))
                        }}
                      </CCol>
                      <CCol class="bg-dark" v-else>{{
                          get_currency(calculate_items(payments_invoice, 'amountNegetive')
                              - calculate_items(payments_invoice, 'amount'))
                        }}
                      </CCol>
                      <CCol></CCol>

                    </CRow>

                  </template>

                </CDataTableFixed>

              </CCol>
              <CCol col="8" v-if="factor_comments.length>0">
                <CCol>شرح های پرداختی</CCol>

                <CDataTableFixed
                    :items="factor_comments"
                    :fields="fields_comments"
                    :items-per-page="200"
                    hover

                    border
                    striped

                >
                  <template #row="{item,index}">
                    <td>
                      <p class="text-center">{{ index + 1 }}</p>
                    </td>
                  </template>

                </CDataTableFixed>

              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
    </CRow>
    <CModal
        title="تغییر وضعیت"
        color="dark"
        size="lg"
        :show.sync="pre_finalize"
    >
      <CSelect
      :options="cartable_statuses"
      label="وضعیت جدید"
      :value.sync="selected_request_status"/>
      <CTextarea
        v-model="request_status_desc"
        placeholder="توضیحات وضعیت"
        />
      <template #footer>
        <CButton @click="pre_finalize = false,change_cartable_status()" color="danger">{{ $t('buttons.ok') }}</CButton>
        <CButton @click="pre_finalize = false" color="primary">{{ $t('buttons.cancel') }}</CButton>
      </template>
    </CModal>

    <div id="qrcode_root" style="display:none;text-align: center;">

      <img id="qrcode_doc" style="margin:10px;width: 80%;height: auto">
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

import ReceiveOperationModal from "../../../views/panel/receiveOperation/ReceiveOperationModal";

var QRCode = require('qrcode')
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css',
    'https://omdesho.ir/print_css/printing.css',

  ]
}

Vue.use(VueHtmlToPaper, options);
var items_data = [];
import moment from 'moment-jalaali'


export default {
  name: 'Login',
  components: {
    ReceiveOperationModal
  },
  data() {
    return {
      user_id: '',
      QRCode: QRCode,
      total_price: '',
      cartable_data: {},
      payTypeTitle: '',
      createdAt: '',
      baseMasterId: '',
      baseMasterCode: '',
      factor_comments: [],
      dialog_recept: false,
      payDueDate: '',
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: '',
      VUE_APP_NAME: localStorage.getItem('app_name'),
      date: '',
      pre_finalize: false,
      cartable_statuses:[],
      selected_request_status:0,
      request_status_desc:'',
      doc_id: '',
      doc_id_no: '',
      company_address: '',
      product_items: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},
      ], fields_low: [
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},

        // {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        // {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        // {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},
      ],
      fields_thermal: [
        // {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},

        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        // {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        // {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        // {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        // {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},

        // {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],

      factor_received_amounts_fields: [
        {key: 'PaymentType', label: "نوع پرداخت", _style: 'padding:0px'},
        {key: 'Price', label: "مبلغ", _style: 'padding:0px'},
      ],
      factor_final_payments: [],
      fields_factor_payments: [
        {key: 'type', label: "نوع", _style: 'padding:0px'},
        {key: 'name', label: "نام", _style: 'padding:0px'},
        {key: 'amount', label: "مبلغ", _style: 'padding:0px'},
        {key: 'operation', label: "#", _style: 'padding:0px'},
      ],

      pre_finalize_items: [{
        tafzili: "9",
        moein: "8",
        kol: "12",
        account: "پرداخت هزینه سوخت",
        price_joz: "120000",

        price_bedehkar: "1000",
        price_bestankar: "1000"
      }, {
        tafzili: "",
        moein: "",
        kol: "",
        account: "",
        price_joz: this.$t('totalDoc'),
        price_bedehkar: "1000",
        price_bestankar: "1000"
      }],
      pre_finalize_fields: [
        {key: 'tafzili', label: this.$t('tafsili'), _style: 'width:3%;padding:0px'},
        {key: 'moein', label: this.$t('moein'), _style: 'width:3%;padding:0px'},
        {key: 'kol', label: this.$t('total'), _style: 'width:3%;padding:0px'},
        {key: 'account', label: this.$t('components.groupName'), _style: 'width:10%;padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'price_joz', label: this.$t('subAmount'), _style: 'width:5%;padding:0px'},
        {key: 'price_bedehkar', label: this.$t('bedehkar'), _style: 'width:5%;padding:0px'},
        {key: 'price_bestankar', label: this.$t('bestankar'), _style: 'width:5%;padding:0px'},

      ],
      fields_total_price: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
        {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

      ],
      fields_total_price_currency: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px'},
        {key: 'resultPriceCurrency', label: this.$t('currency'), _style: 'padding:5px;'},
        {key: 'resultPrice', label: localStorage.getItem('currency_name'), _style: 'padding:5px;'},

      ],

      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),
      selectedTypeLabelRevert: this.$t('buttons.buyer'),
      selectedTypeTitle: this.$t('components.documentBuy'),
      tablo: '',
      address: '',

      partyMobile: '',
      tozikonandeMobile: '',


      document_person: '',
      document_person_data: {},
      document_person_id: '',
      document_summary: '',
      document_visitor: '',
      document_driver: '',

      phone_objects: [],
      email_objects: [],
      website_objects: [],


      messages_items: [],
      person_email: [],

      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',

      unit_items: [],
      doc_status: 0,
      total_weight: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items_filtered: [],
      selected_place: '',
      selected_product: null,

      status_form: 0,
      document_result_price: [],
      document_result_price_currency: [],
      bissiness_profile: {},
      main_address: {},
      key_handler: null,
      factor_received_amounts: {},
      payments_invoice: [],
      fields_payments_invoice: [
        {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%;text-align:center'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
        {key: 'accNo', label: this.$t('docNumber'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:10%'},

        {key: 'amountNegetive', label: this.$t('bedehkar'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('bestankar'), _style: 'width:10%'},

        {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},
      ],
      fields_comments: [
        {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%;text-align:center'},
        {key: 'createdBy', label: this.$t('user'), _style: 'width:10%'},
        {key: 'commentText', label: this.$t('tables.summary'), _style: 'width:50%'},
      ],
    }
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.key_handler);
  },
  mounted() {
    this.user_id = localStorage.getItem('user_id');
    this.doc_id = this.$route.params.doc_id;
    this.$root.root_validate_errors = [];

    this.get_product_units();
    this.get_bussiness_profile();
    this.get_main_address();
    this.get_contact();
    this.get_cartable_statuses();

    bus.$on("update_add_receive", (data) => {
      // alert(data);
      this.dialog_recept = false;

    });
    bus.$on('delete_confirm_factor' + this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  created() {
    var self = this
    this.key_handler = function (e) {

    }
    window.addEventListener('keyup', this.key_handler);
  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    'total_price': function () {
      try {
        this.cashiers[0].amount = 0
        this.terminals[0].amount = parseFloat(this.total_price).toFixed(0)
      } catch (e) {

      }

    },
    'terminals': {
      handler: function () {
      }, deep: true
    },
    'cashiers': {
      handler: function () {
      }, deep: true
    },

  },
  methods: {
    open_document(type){
      if(type==1){
        window.open('/dashboard/documents/add-purchase-cartable/1/'+this.doc_id)
      }
      if(type==3){
        window.open('/dashboard/sale-orders/add-cartable-sale-invoice/'+this.doc_id+"/"+this.cartable_data.ownerName+"/"+this.cartable_data.ownerId)
      }
    },
get_cartable_statuses(){
    var self = this;
    console.log("route id " + this.$route.params.cat_id);

    const formData = new FormData();


    // formData.append('id', this.selected_province);

    formData.append("Id",0)
    axios.post('GetStatusesById', formData, {
      params: {
        // isparent : self.$route.params.cat_id
      },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }).then(function (response) {

      var content_data = response.data;
      // items = content_cats.orders;
      if (content_data.statusCode == 0) {
        self.cartable_statuses = [{label:'انتخاب کنید',value:0}]
        self.cartable_statuses = self.sort_array(self.cartable_statuses,content_data.data,'id','statusTitle')

      } else {
        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

      }


    })
        .catch(function (error) {

          console.log(error);
        });

},
change_cartable_status(){
    var self = this;
    console.log("route id " + this.$route.params.cat_id);

    const formData = new FormData();


    // formData.append('id', this.selected_province);
    formData.append("requestId",this.doc_id)
    formData.append("statusId",this.selected_request_status)
    formData.append("statusId",this.request_status_desc)
    axios.post('AddRequestStatus', formData, {
      params: {
        // isparent : self.$route.params.cat_id
      },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }).then(function (response) {

      var content_data = response.data;
      // items = content_cats.orders;
      if (content_data.statusCode == 0) {
       self.get_document_master()
      } else {
        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

      }


    })
        .catch(function (error) {

          console.log(error);
        });

},
    finalize(to_print) {
      var self = this;
      const formData = new FormData();

      var url = "AddFactorToFinal";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          if (to_print) {
            self.get_document_master("print");
          } else {
            self.get_document_master();
          }

        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_contact() {
      var self = this;

      const formData = new FormData();

      axios.post('GetContactById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.phone_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.email_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.website_objects = [{phone_type: 19, phone: '', row_id: 1}]
          if (content_data.data.length) {
            self.phone_objects = []
            self.email_objects = []
            self.website_objects = []

          }
          content_data.data.forEach((val) => {
            if (val.contactType == 1) {
              self.phone_objects.push({phone: val.contactText});
            }
            if (val.contactType == 2) {
              self.email_objects.push({phone: val.contactText});

            }
            if (val.contactType == 3) {
              self.website_objects.push({phone: val.contactText});

            }


          });
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_factor_comments() {
      var self = this;

      const formData = new FormData();
      formData.append("Id", this.doc_id);
      axios.post('GetFactorCommentsById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data

          self.factor_comments = content_data.data;
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = content_data.data;
          self.get_document_master();


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    print() {
      // Pass the element id here
      // this.print_with_header_title('printMe', 'print_report_header', 'print_report_footer', this.doc_id_no);
      this.print_with_header_title_height('printMe', 'print_report_header', 'print_report_footer', this.doc_id_no, 300, 350)

      // this.$htmlToPaper('printMe');
    },
    goEdit() {
      // Pass the element id here

      this.$router.push({path: "/dashboard/documents/edit-document/" + this.doc_id});

    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_document_master(print) {
      var self = this;


      const formData = new FormData();

      var url = "GetServiceReqByParam";

      formData.append("Id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}

          self.cartable_data = content_data.data

          // self.document_person = content_data.data.partyName;
          self.document_person_id = content_data.data.ownerId;
          self.date = content_data.data.docDate;
          self.createdAt = content_data.data.createdAt;

          self.doc_status = content_data.data.statusId;
          self.address = content_data.data.addressText;
          self.doc_id_no = content_data.data.requestCode;
          document.title = self.doc_id_no;
          self.get_user_data()

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    delete_item_dialog() {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_factor' + this.confirm_delete_name);

      // this.status_form = this.masterFactorId;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFactorMaster";


      formData.append('id', this.doc_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();
        //  this.$router.push({ path: '/dashboard/documents/daily-list/0'});
        self.$router.go(-1)

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person_id);


      axios.post(url, formData, {}).then((res) => {
        //
        var person = res.data.data.person;

        self.document_person = person.personCode
        self.document_person += " " + person.personName
        if (person.middelName != null) {
          self.document_person += " " + person.middelName
        }
        if (person.surName != null) {
          self.document_person += " " + person.surName
        }
        self.get_person_remaining_amount();

        // var tota_price = self.document_result_price[self.document_result_price.length - 1].resultPrice;
        // tota_price = tota_price.replaceAll(",", "");

        // tota_price = parseInt(res.data.data.mande) + parseInt(tota_price)
        if (res.data.data.personContacts.filter(x => x.contactType == 18).length > 0) {
          self.person_email = res.data.data.personContacts.filter(x => x.contactType == 18)[0].contact

        }
        if (res.data.data.personContacts.filter(x => x.contactType == 19).length > 0) {
          self.partyMobile = res.data.data.personContacts.filter(x => x.contactType == 19)[0].contact


        }
        // console.log("person email is ",self.person_email);
        // self.document_result_price.push(obj)
        // obj = {resultTitle: "مبلغ نهایی", resultPrice:tota_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") };

        self.document_person_data = res.data.data;
      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_person_remaining_amount() {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));


      formData.append('TafsiliType', 2);
      formData.append('id', this.doc_id);

      formData.append('PartyId', this.document_person_id);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);

      let url = 'GetPersonAccountsByPersonId_New'
      url = "GetLastPartyAccountByParam"
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // var items1 = content_data.data.personAccountItems
          // items1.forEach(function (val,index) {
          //   if(index==0) {
          //     val.reminingBefore = 0;
          //     if(val.natureId==0 && items1.length>0){
          //       val.natureId = items1[index+1].natureId;
          //     }
          //   }else{
          //     val.reminingBefore = self.items[index-1].accBalance;
          //
          //     if(val.natureId==2){
          //       val.accBalance = parseFloat(val.reminingBefore) +  parseFloat(val.amount);
          //       if(val.amount>0){
          //         val.amountNegetive=Math.abs(val.amount);
          //         val.amount=0;
          //
          //       }else{
          //         val.amount=Math.abs(val.amount);
          //         val.amountNegetive=0;
          //       }
          //     }else{
          //
          //       val.accBalance = parseFloat(val.reminingBefore)   + parseFloat(val.amount);
          //       if(val.amount<0){
          //         val.amountNegetive=0;
          //         val.amount=Math.abs(val.amount);
          //
          //       }else{
          //         val.amountNegetive=Math.abs(val.amount);
          //         val.amount=0;
          //
          //       }
          //     }
          //   }
          //   self.document_person_remain_amount =items1[items1.length-1].accBalance
          // if(self.get_access("remaining_before_in_invoice")){
          //   var last_price = self.document_result_price[self.document_result_price.length-1].resultPrice
          //   var last_price_final = self.document_person_remain_amount - last_price
          //   var  obj = {resultTitle: "مانده  از قبل", resultPrice: last_price_final};
          //   self.document_result_price.push(obj)
          //   obj = {resultTitle: "مانده طرف حساب", resultPrice: self.document_person_remain_amount};
          //   self.document_result_price.push(obj)
          // }


          // })
          self.document_person_remain_amount = response.data.data.balance
          if (self.get_access("remaining_before_in_invoice")) {
            var last_price = self.document_result_price[self.document_result_price.length - 1].resultPrice
            var last_price_final = 0;

            last_price_final = self.document_person_remain_amount + last_price

            var obj = {resultTitle: "مانده  از قبل", resultPrice: self.document_person_remain_amount};
            self.document_result_price.push(obj)
            obj = {resultTitle: "مانده طرف حساب", resultPrice: last_price_final};
            self.document_result_price.push(obj)
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_bussiness_profile() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.bissiness_profile_id);


      axios.post('GetProfileById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bissiness_profile = content_data.data
          self.previewImage = localStorage.getItem("api_address") + "/images/Business/" + content_data.data.logo
          localStorage.setItem("app_logo", localStorage.getItem("api_address") + "/images/Business/" + content_data.data.logo)
          document.getElementById("logo_image").src = localStorage.getItem("app_logo")
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_main_address() {
      var self = this;

      const formData = new FormData();


      axios.post('GetAddressById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.main_address = content_data.data

          self.company_address = self.main_address.cityName + " " + self.main_address.street + " " + self.main_address.houseNO + " " + self.main_address.postCode;


        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

  }

}

</script>
